import { Badge, BadgeVariations, isNullOrEmpty, renderDecimal, typedMemo } from '@synqo/frontend-component-library';
import type { EnumUnit } from '@Model';
import { getShortUnitLabel } from '@Model';
import { useMemo } from 'react';

interface IWeighingSlipBadgeProps {
    number: string;
    externalId: string;
    net: number;
    unit: EnumUnit;
}

function MemoizableWeighingSlipBadge(props: IWeighingSlipBadgeProps) {
    const isExternal = !isNullOrEmpty(props.externalId);

    const variant: BadgeVariations = isExternal ? 'accent' : 'primary';

    const label = useMemo(() => {
        const basicLabel = `WS${props.number}`;
        if (isExternal) {
            return `${basicLabel} (${props.externalId})`;
        }
        return basicLabel;
    }, [isExternal, props.number, props.externalId]);

    return (
        <Badge variant={variant}>
            {label}&nbsp;
            <b>{`${renderDecimal(props.net, 3)} ${getShortUnitLabel(props.unit)}`}</b>
        </Badge>
    );
}

export const WeighingSlipBadge = typedMemo(MemoizableWeighingSlipBadge);
